<template>
  <div class="client-container" :style="customStyle">
    <!-- TEMPLATE 1: Simple Centered -->
    <div v-if="templateId === '1'" class="template-1 centered-layout">
      <div class="hero-section" :style="{ backgroundColor: color || 'black' }">
        <img v-if="srcImg" :src="srcImg" class="logo-img" alt="Logo" />
        <h1 class="welcome-text">{{ welcome || $t('client_welcome_msg') }}</h1>
      </div>
      <div class="actions-grid">
        <div class="action-card" @click="goMenu">
          <i class="fas fa-utensils"></i>
          <span>{{ $t('client_menu') }}</span>
        </div>
        <div class="action-card asporto-card" @click="goAsporto">
          <i class="fas fa-shopping-bag"></i>
          <span>{{ $t('client_asporto') }}</span>
        </div>
        <div class="action-card" @click="goDolciCaffe">
          <i class="fas fa-coffee"></i>
          <span>{{ $t('client_dolci') }}</span>
        </div>
        <div class="action-card" @click="goDiconoDiNoi">
          <i class="fas fa-star"></i>
          <span>{{ $t('client_feedback') }}</span>
        </div>
        <div class="action-card prenota-card" @click="goPrenotaTavolo">
          <i class="fas fa-calendar-check"></i>
          <span>{{ $t('prenota_tavolo') }}</span>
        </div>
      </div>
      <div class="footer-msg" :style="{ backgroundColor: color || 'black' }">
        {{ $t('client_footer') }}
        <div class="waiter-call" @click="goCallwaiter">
          <img src="../assets/waiter.svg" class="waiter-icon" />
        </div>
      </div>
    </div>

    <!-- TEMPLATE 2: Minimalist -->
    <div v-else-if="templateId === '2'" class="template-2 minimal-layout">
      <nav class="minimal-nav">
        <img v-if="srcImg" :src="srcImg" class="mini-logo" alt="Logo" />
        <div class="waiter-dot" @click="goCallwaiter"></div>
      </nav>
      <main class="minimal-main">
        <h2 class="minimal-welcome">{{ welcome || $t('client_welcome_msg') }}</h2>
        <div class="minimal-links">
          <button @click="goMenu" class="btn-minimal">{{ $t('client_menu') }}</button>
          <button @click="goAsporto" class="btn-minimal asporto-outline">{{ $t('client_asporto') }}</button>
          <button @click="goDolciCaffe" class="btn-minimal">{{ $t('client_dolci') }}</button>
          <button @click="goPrenotaTavolo" class="btn-minimal prenota-outline">{{ $t('prenota_tavolo') }}</button>
        </div>
      </main>
      <p class="minimal-footer">{{ $t('client_footer') }}</p>
    </div>

    <!-- TEMPLATE 3: Gradient / Modern -->
    <div v-else-if="templateId === '3'" class="template-3 modern-gradient">
      <div class="gradient-overlay"></div>
      <div class="modern-content">
        <div class="modern-header">
          <img v-if="srcImg" :src="srcImg" class="modern-logo" alt="Logo" />
          <p class="modern-quote">{{ welcome || $t('client_welcome_msg') }}</p>
        </div>
        <div class="modern-buttons">
          <div class="m-btn main-m-btn" @click="goMenu">
            <span class="m-icon">🍽️</span>
            <span class="m-text">{{ $t('client_menu') }}</span>
          </div>
          <div class="m-btn asporto-m-btn" @click="goAsporto">
             <span class="m-icon">🥡</span>
            <span class="m-text">{{ $t('client_asporto') }}</span>
          </div>
          <div class="m-btn prenota-m-btn" @click="goPrenotaTavolo">
             <span class="m-icon">📅</span>
            <span class="m-text">{{ $t('prenota_tavolo') }}</span>
          </div>
        </div>
        <div class="modern-bottom-nav">
          <div class="nav-item" @click="goDolciCaffe">{{ $t('client_dolci') }}</div>
          <div class="nav-item" @click="goDiconoDiNoi">{{ $t('client_feedback') }}</div>
          <div class="nav-item waiter-btn" @click="goCallwaiter">🛎️</div>
        </div>
      </div>
    </div>

    <!-- TEMPLATE 4: Classic Elegant (About Us) -->
    <div v-else-if="templateId === '4'" class="template-4 elegant-classic">
      <header class="classic-header" :style="{ borderColor: color }">
        <img v-if="srcImg" :src="srcImg" class="classic-logo" alt="Logo" />
        <h1 class="classic-title">{{ welcome || 'Ristorante Fiore' }}</h1>
      </header>
      <div class="classic-body">
        <section class="about-us-section">
          <h3>{{ $t('about') }}</h3>
          <p class="about-text">{{ chiSiamoText || 'Benvenuti nel nostro ristorante, dove la tradizione incontra l\'innovazione.' }}</p>
        </section>
        <div class="classic-actions">
          <button class="classic-btn" @click="goMenu">{{ $t('client_menu') }}</button>
           <button class="classic-btn asporto-btn" @click="goAsporto">{{ $t('client_asporto') }}</button>
          <button class="classic-btn prenota-btn" @click="goPrenotaTavolo">{{ $t('prenota_tavolo') }}</button>
        </div>
      </div>
      <footer class="classic-footer" :style="{ backgroundColor: color }">
        <div @click="goCallwaiter" class="classic-waiter">
           <img src="../assets/waiter.svg" />
           <span>{{ $t('call_us') }}</span>
        </div>
      </footer>
    </div>

    <!-- TEMPLATE 5: Modern Restaurant (About Us + Image focus) -->
    <div v-else-if="templateId === '5'" class="template-5 modern-restaurant">
      <div class="restaurant-hero" :style="{ backgroundImage: srcImg ? 'url(' + srcImg + ')' : 'none' }">
        <div class="hero-content">
          <h1 class="res-title">{{ welcome || $t('client_welcome_msg') }}</h1>
          <button class="res-cta" @click="goMenu">{{ $t('client_menu') }}</button>
        </div>
      </div>
      <div class="restaurant-info">
        <div class="res-about">
          <h3>Il Nostro Posto</h3>
          <p>{{ chiSiamoText || 'Una location unica per i tuoi momenti speciali.' }}</p>
        </div>
        <div class="res-links">
           <div class="res-link-item" @click="goAsporto">
             <strong>{{ $t('client_asporto') }}</strong>
             <small>Porta il gusto a casa</small>
           </div>
           <div class="res-link-item" @click="goDolciCaffe">
             <strong>{{ $t('client_dolci') }}</strong>
             <small>Un dolce finale</small>
           </div>
           <div class="res-link-item prenota-res-link" @click="goPrenotaTavolo">
             <strong>{{ $t('prenota_tavolo') }}</strong>
             <small>Riserva il tuo posto</small>
           </div>
        </div>
      </div>
      <div class="res-footer" :style="{ background: color }">
        <span @click="goCallwaiter">🛎️ {{ $t('call_waiter') }}</span>
        <span>© 2024 MyMenu</span>
      </div>
    </div>

<!-- TEMPLATE 6: Fresh Modern (Home FULL) -->
<div v-else-if="templateId === '6'" class="template-6 fresh-modern">
  <!-- HERO SECTION -->
    <div class="t6-hero">
    <img v-if="srcImg" :src="srcImg" class="t6-logo" alt="Logo" style="max-height: 120px; border-radius: 12px; margin-bottom: 20px; object-fit: contain;" />
    <h1 class="t6-title" :style="{ color: color || '#1a202c' }">
      {{ welcome || 'Ristorante Fresco' }}
    </h1>
    <p class="t6-subtitle">
      {{ subtitle || "Cucina autentica, ingredienti selezionati e un'atmosfera moderna. Scopri i nostri piatti oppure ordina comodamente da casa." }}
    </p>
    
    <div class="t6-actions">
      <button class="t6-btn t6-btn-dark" @click="goMenu" :style="{ backgroundColor: color || '#111827' }">
        <i class="fas fa-utensils"></i> {{ $t('client_menu') }}
      </button>
       <button class="t6-btn t6-btn-outline" @click="goAsporto">
        <i class="fas fa-shopping-bag"></i> {{ $t('client_asporto') }}
      </button>
      <button class="t6-btn t6-btn-outline" @click="goPrenotaTavolo">
        <i class="fas fa-calendar-alt"></i> {{ $t('prenota_tavolo') }}
      </button>
    </div>
  </div>

  <!-- CARDS SECTION -->
  <div class="t6-features">
    <div class="t6-card">
      <i class="far fa-clock t6-icon"></i>
      <h4>Orari Flessibili</h4>
      <p>{{ openingHours || 'Aperto tutti i giorni dalle 12:00 alle 23:00.' }}</p>
    </div>
    <div class="t6-card">
      <i class="fas fa-map-marker-alt t6-icon"></i>
      <h4>Posizione Centrale</h4>
      <p>{{ address || 'Nel cuore della città, facilmente raggiungibile.' }}</p>
    </div>
    <div class="t6-card">
      <i class="far fa-star t6-icon"></i>
      <h4>Qualità Garantita</h4>
      <p>{{ qualityText || 'Ingredienti freschi e recensioni a 5 stelle.' }}</p>
    </div>
  </div>

  <!-- CTA SECTION -->
  <div class="t6-cta">
    <h2 class="t6-cta-title" :style="{ color: color || '#1a202c' }">Prenota un tavolo o ordina ora</h2>
    <p class="t6-cta-subtitle">
      {{ description || "Vivi l'esperienza del nostro ristorante direttamente in sala oppure comodamente a casa tua." }}
    </p>
    <div class="t6-actions">
      <button class="t6-btn t6-btn-dark" @click="goMenu" :style="{ backgroundColor: color || '#111827' }">
        {{ $t('client_menu') }}
      </button>
      <button class="t6-btn t6-btn-outline" @click="goAsporto">
        {{ $t('client_asporto') }}
      </button>
    </div>
  </div>

  <!-- MAPS SECTION -->
  <div v-if="mapsEmbedUrl" class="t6-map-section">
     <iframe :src="mapsEmbedUrl" width="100%" height="350" style="border:0; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);" allowfullscreen="" loading="lazy"></iframe>
  </div>

  <!-- FOOTER STRIP -->
  <div class="t6-footer-strip">
    <div class="t6-contact-info">
      <a v-if="email" :href="`mailto:${email}`" class="t6-contact-link"><i class="far fa-envelope"></i></a>
      <a v-if="phone" :href="`tel:${phone}`" class="t6-contact-link"><i class="fas fa-phone"></i></a>
      <span v-if="partitaIva" class="t6-piva">P.IVA: {{ partitaIva }}</span>
    </div>
    <div class="t6-waiter" @click="goCallwaiter">
       <img src="../assets/waiter.svg" class="waiter-icon" />
       <span>{{ $t('call_us') }}</span>
    </div>
  </div>

</div>

  <div v-if="ordineAttivo && ordineAttivo.rimanente > 0" class="public-payment-overlay">
    <button class="pay-btn-shared" @click="pagaConto">
      <i class="fas fa-credit-card"></i> {{ $t('paga_conto') }} ({{ (ordineAttivo.rimanente || 0).toFixed(2) }} €)
    </button>
  </div>

  <!-- Order Recap Modal -->
  <div v-if="showRecapModal" class="recap-modal-overlay" @click.self="showRecapModal = false">
    <div class="recap-modal">
      <div class="recap-header">
        <h2>{{ $t('riepilogo_ordine') || 'Riepilogo Ordine' }}</h2>
        <button class="close-recap" @click="showRecapModal = false">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="recap-body">
        <!-- STEP 1: Recap and Choice -->
        <template v-if="paymentStep === 'reciproco'">
          <div v-for="(item, index) in ordineAttivo.ordinazione" :key="index" class="recap-item">
            <div class="item-main-info">
              <span class="item-qty-tag">{{ item.quantita || 1 }}x</span>
              <span class="item-name-text">{{ item.piatto }}</span>
              <span v-if="item.pagato" class="badge-pagato">Pagato</span>
            </div>
            <div class="item-price-val">{{ ((item.prezzo + (item.costoAggiunta || 0)) * (item.quantita || 1)).toFixed(2) }} €</div>
            <div v-if="item.aggiunta && item.aggiunta.length" class="item-extras">
              <small>+ {{ item.aggiunta.join(', ') }}</small>
            </div>
          </div>
        </template>

        <!-- STEP 2: Choice Mode -->
        <template v-if="paymentStep === 'choice'">
          <div class="payment-modes">
            <p class="modes-intro">Scegli come procedere:</p>
            
            <button class="btn-mode-premium" @click="paymentStep = 'reciproco'">
              <div class="mode-icon-box icon-full"><i class="fas fa-receipt"></i></div>
              <div class="mode-content">
                <h4>Paga Tutto</h4>
                <p>Salda l'intero importo rimanente</p>
              </div>
              <i class="fas fa-chevron-right chevron-arrow"></i>
            </button>

            <button class="btn-mode-premium" @click="paymentStep = 'split'">
              <div class="mode-icon-box icon-split"><i class="fas fa-users"></i></div>
              <div class="mode-content">
                <h4>Dividi il totale</h4>
                <p>Dividi il conto in parti uguali</p>
              </div>
              <i class="fas fa-chevron-right chevron-arrow"></i>
            </button>

            <button class="btn-mode-premium" @click="paymentStep = 'items'">
              <div class="mode-icon-box icon-items"><i class="fas fa-utensils"></i></div>
              <div class="mode-content">
                <h4>Scegli i piatti</h4>
                <p>Paga solo i piatti selezionati</p>
              </div>
              <i class="fas fa-chevron-right chevron-arrow"></i>
            </button>
          </div>
        </template>

        <!-- STEP 3: Split Mode -->
        <template v-if="paymentStep === 'split'">
          <div class="form-field">
            <label class="form-label">{{ splittingInProgress ? 'Divisione fissa attiva:' : 'Dividi il totale per:' }}</label>
            <input type="number" v-model="numSplits" min="2" max="50" class="premium-input" :disabled="splittingInProgress">
            <p class="split-preview">{{ splittingInProgress ? 'La tua quota:' : 'Ogni quota:' }} <strong>{{ (ordineAttivo.totale / numSplits).toFixed(2) }} €</strong></p>
          </div>
        </template>

        <!-- STEP 4: Items Mode -->
        <template v-if="paymentStep === 'items'">
          <div class="items-list-premium">
            <div v-for="(item, index) in ordineAttivo.ordinazione" :key="index" 
                 class="selection-card" :class="{ 'paid': item.pagato, 'selected': selectedItemIndices.includes(index) }"
                 @click="!item.pagato && toggleItemSelection(index)">
              <div class="selection-check">
                <i v-if="item.pagato" class="fas fa-check-circle" style="color: #cbd5e1;"></i>
                <i v-else class="fas" :class="selectedItemIndices.includes(index) ? 'fa-check-circle' : 'fa-circle'" 
                   :style="{ color: selectedItemIndices.includes(index) ? '#10b981' : '#e2e8f0' }"></i>
              </div>
              <span class="item-name-text">{{ item.piatto }}</span>
              <span class="item-price-val" style="margin-left: auto;">{{ ((item.prezzo + (item.costoAggiunta || 0)) * (item.quantita || 1)).toFixed(2) }} €</span>
              <div v-if="item.pagato" class="paid-badge-small">PAGATO</div>
            </div>
          </div>
        </template>

        <!-- Email input (for all modes) -->
        <div v-if="paymentStep !== 'choice'" class="form-field">
          <label class="form-label">Email per la ricevuta:</label>
          <input type="email" v-model="paymentEmail" placeholder="esempio@mail.com" class="premium-input">
        </div>
      </div>

      <div class="recap-footer-premium">
        <div class="total-row">
          <span class="total-label">{{ $t('totale') || 'Totale' }}</span>
          <span class="total-amount">{{ currentPaymentAmount.toFixed(2) }} €</span>
        </div>
        <div class="actions-container">
          <button class="btn-secondary-premium" @click="handleCancel">
            {{ cancelButtonText }}
          </button>
          
          <button v-if="paymentStep === 'reciproco'" class="btn-mode-toggle" @click="paymentStep = 'choice'">
            Parziale
          </button>
          
          <button v-if="paymentStep !== 'choice'" class="btn-primary-premium" @click="confirmAndPay" :disabled="isPayDisabled">
            <i class="fas fa-credit-card"></i> Paga Ora
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { store } from "../store/store.js";
import { io } from "socket.io-client"
export default {
  name: "Benvenuto",
  data: function () {
    return {
      piatti: [],
      color: "",
      welcome: "",
      templateId: "1",
      chiSiamoText: "",
      srcImg: "",
      subtitle: "",
      description: "",
      openingHours: "",
      address: "",
      qualityText: "",
      phone: "",
      mapsEmbedUrl: "",
      email: "",
      partitaIva: "",
      ordineAttivo: null,
      showRecapModal: false,
      paymentStep: 'reciproco', // reciproco, choice, split, items
      paymentEmail: '',
      numSplits: 2,
      selectedItemIndices: [],
      tableData: { sala: '', numero: '' },
      store,
      socket:io(process.env.VUE_APP_SOCKET_URL, { autoConnect: true }),
      windowWidth: window.innerWidth
    };
  },
  methods: {
    displayLayout() {
      this.axios
        .post(this.store.path + "displaylayout", {
          headers: {
            authorization: `Bearer  ${localStorage.getItem('token') ? JSON.parse(localStorage.getItem('token')) : ''}`,
          },
        })
        .then((response) => {
          if (response.data) {
            this.welcome = response.data.wel;
            this.color = response.data.col;
            this.templateId = response.data.templateId || "1";
            this.chiSiamoText = response.data.chiSiamoText || "";
            this.subtitle = response.data.subtitle || "";
            this.description = response.data.description || "";
            this.openingHours = response.data.openingHours || "";
            this.address = response.data.address || "";
            this.qualityText = response.data.qualityText || "";
            this.phone = response.data.phone || "";
            this.mapsEmbedUrl = response.data.mapsEmbedUrl || "";
            this.email = response.data.email || "";
            this.partitaIva = response.data.partitaIva || "";
            let type = response.data.type;
            if (type) {
              let splitPat1 = this.store.path.split("/")[0];
              let splitPat2 = this.store.path.split("/")[2];
              this.srcImg = `${splitPat1}//${splitPat2}/immagine.${type}`;
            }
          }
        });
    },
    goMenu() {
      this.$router.push({ name: "Menu" });
    },
    goAsporto() {
      this.$router.push({ name: "OrdineAsporto" });
    },
    goPrenotaTavolo() {
      this.$router.push("/prenota-tavolo");
    },
    goProposte() {
      console.log(window.location.hash);
    },
    goDolciCaffe() {},
    goDiconoDiNoi() {},
    goCallwaiter() {
      const sala = this.tableData.sala;
      const numero = this.tableData.numero;
      this.socket.emit('chiamatoCameriere', {sala, tavolo:numero});
    },
    setTavolo() {
      const hash = window.location.hash; // e.g. #interna-t5
      console.log("🔍 setTavolo: hash =", hash);
      localStorage.setItem("tavolo", JSON.stringify(hash));
      
      if (hash && hash.includes('-')) {
        const parts = hash.substring(1).split('-');
        this.tableData.sala = parts[0];
        this.tableData.numero = parts[1];
        console.log("📍 Parsed Table Data:", this.tableData);
        this.checkOrdineAttivo();
      }
    },
    checkOrdineAttivo() {
      if (!this.tableData.sala || !this.tableData.numero) return;

      console.log("📡 Calling getOrdinePubblico for:", this.tableData.sala, this.tableData.numero);
      console.log("🔗 API Path:", this.store.path + 'getOrdinePubblico');

      this.axios.post(this.store.path + 'getOrdinePubblico', {
        sala: this.tableData.sala,
        numero: this.tableData.numero
      }).then((response) => {
        console.log("📥 getOrdinePubblico Response:", response.data);
        if (response.data && response.data.totale > 0) {
          this.ordineAttivo = response.data;
          console.log("✅ ordineAttivo set to:", this.ordineAttivo);
        }
      }).catch(err => {
        console.error("❌ getOrdinePubblico Error:", err.response ? err.response.data : err.message);
        this.ordineAttivo = null;
      });
    },
    pagaConto() {
      if (!this.tableData.sala || !this.tableData.numero || !this.ordineAttivo) return;
      
      if (this.splittingInProgress) {
        this.paymentStep = 'split';
        this.numSplits = this.existingSplitFactor;
      } else if (this.itemsPaymentInProgress || this.someItemsPaid) {
        this.paymentStep = 'items';
        this.selectedItemIndices = []; // Reset selection when opening
      } else {
        this.paymentStep = 'choice';
      }
      
      this.showRecapModal = true;
    },
    toggleItemSelection(index) {
      if (this.ordineAttivo.ordinazione[index].pagato) return;
      const pos = this.selectedItemIndices.indexOf(index);
      if (pos > -1) this.selectedItemIndices.splice(pos, 1);
      else this.selectedItemIndices.push(index);
    },
    handleCancel() {
      if (this.paymentStep === 'reciproco' || 
          (this.paymentStep === 'split' && this.splittingInProgress) ||
          (this.paymentStep === 'items' && (this.itemsPaymentInProgress || this.someItemsPaid))) {
        this.showRecapModal = false;
      } else if (this.paymentStep === 'choice') {
        this.paymentStep = 'reciproco';
      } else {
        this.paymentStep = 'choice';
      }
    },
    confirmAndPay() {
      let endpoint = 'creaSessionePagamentoTavoloPubblico';
      let params = {
        sala: this.tableData.sala,
        numero: this.tableData.numero,
        email: this.paymentEmail
      };

      if (this.paymentStep === 'items' && this.selectedItemIndices.length === 0) {
        alert("Seleziona almeno un piatto per procedere.");
        return;
      }

      if (this.paymentStep !== 'reciproco') {
        endpoint = 'creaSessionePagamentoParzialePubblico';
        params.tipo = this.paymentStep === 'split' ? 'divisione' : 'piatti';
        params.email = this.paymentEmail;
        if (params.tipo === 'divisione') params.numDivisioni = this.numSplits;
        else params.indices = this.selectedItemIndices;
      }

      this.axios.post(this.store.path + endpoint, params).then((response) => {
        if (response.data && response.data.sessionUrl) {
          window.location.href = response.data.sessionUrl;
        } else {
          alert("Errore nella generazione del pagamento.");
        }
      }).catch(err => {
        console.error("Errore Stripe Pubblico:", err);
        alert("Impossibile avviare il pagamento.");
      });
    },
  },
  computed: {
    currentPaymentAmount() {
      if (!this.ordineAttivo) return 0;
      if (this.paymentStep === 'reciproco' || this.paymentStep === 'choice') return this.ordineAttivo.rimanente || 0;
      if (this.paymentStep === 'split') {
        const quota = (this.ordineAttivo.totale || 0) / (this.numSplits || 1);
        return Math.min(quota, this.ordineAttivo.rimanente || 0);
      }
      if (this.paymentStep === 'items') {
        return this.selectedItemIndices.reduce((acc, idx) => {
          const item = this.ordineAttivo.ordinazione[idx];
          return acc + (item ? (item.prezzo + (item.costoAggiunta || 0)) * (item.quantita || 1) : 0);
        }, 0);
      }
      return 0;
    },
    isPayDisabled() {
      // General validation: need an active order and a valid email
      if (!this.ordineAttivo || !this.paymentEmail || !this.paymentEmail.includes('@')) return true;
      
      if (this.paymentStep === 'reciproco') return false;
      if (this.paymentStep === 'split') return this.numSplits < 2;
      if (this.paymentStep === 'items') {
        return this.selectedItemIndices.length === 0 || 
               this.selectedItemIndices.some(idx => this.ordineAttivo.ordinazione[idx].pagato);
      }
      return true;
    },
    splittingInProgress() {
      return this.ordineAttivo?.pagamentiParziali?.some(p => p.tipo === 'divisione');
    },
    itemsPaymentInProgress() {
      return this.ordineAttivo?.pagamentiParziali?.some(p => p.tipo === 'piatti');
    },
    someItemsPaid() {
      return this.ordineAttivo?.ordinazione?.some(item => item.pagato);
    },
    existingSplitFactor() {
      const p = this.ordineAttivo?.pagamentiParziali?.find(p => p.tipo === 'divisione');
      return p ? p.numDivisioni : 2;
    },
    customStyle() {
        return {
            '--theme-color': this.color || '#000000'
        }
    },
    cancelButtonText() {
      const isMobile = this.windowWidth < 600;
      if (this.paymentStep === 'reciproco') {
        return isMobile ? '❌' : (this.$t('annulla') || 'Annulla');
      }
      return isMobile ? '⬅️' : 'Indietro';
    }
  },
  watch: {
    '$route.hash': {
      handler: function(newHash) {
        console.log("Hash changed:", newHash);
        this.setTavolo();
      },
      immediate: true
    }
  },
  beforeMount() {
    this.setTavolo();
    this.displayLayout();
    this.resizeHandler = () => {
      this.windowWidth = window.innerWidth;
    };
    window.addEventListener('resize', this.resizeHandler);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
  },

};
</script>

<style scoped>
.client-container {
    min-height: 100vh;
    width: 100%;
    color: #333;
    font-family: 'Inter', -apple-system, sans-serif;
    transition: all 0.3s ease;
}

/* TEMPLATE 1: Simple Centered */
.template-1 {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}
.hero-section {
    flex: 3;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    padding: 20px;
    text-align: center;
}
.logo-img {
    max-width: 100%;
    height: auto;
    width: 250px;
    margin-bottom: 20px;
    border-radius: 20px;
    object-fit: contain;
}
@media (max-width: 600px) {
    .logo-img { width: 80%; }
}
.actions-grid {
    flex: 4;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    padding: 20px;
    background: #f8f9fa;
}
.action-card {
    background: white;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0 4px 6px rgba(0,0,0,0.05);
    cursor: pointer;
    padding: 15px;
    font-weight: 600;
}
.asporto-card {
    background: var(--theme-color);
    color: white;
}
.footer-msg {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    color: white;
    font-size: 0.9rem;
}

/* TEMPLATE 2: Minimalist */
.template-2 {
    background: white;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    padding: 40px 20px;
}
.minimal-nav {
    display: flex;
    justify-content: center;
    align-items: center;
}
.mini-logo { 
    max-width: 100%;
    max-height: 35vh; 
    width: 300px;
    height: auto;
    margin-bottom: 20px;
    object-fit: contain;
}
@media (max-width: 600px) {
    .mini-logo { width: 90%; }
}
.waiter-dot {
    width: 15px;
    height: 15px;
    background: var(--theme-color);
    border-radius: 50%;
}
.minimal-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.btn-minimal {
    display: block;
    width: 100%;
    padding: 15px;
    margin: 10px 0;
    border: 1px solid #eee;
    background: transparent;
    border-radius: 4px;
    letter-spacing: 2px;
}

/* TEMPLATE 3: Modern Gradient */
.modern-gradient {
    position: relative;
    min-height: 100vh;
    background: #121212;
}
.modern-logo {
    max-width: 100%;
    max-height: 250px;
    width: 80%;
    height: auto;
    margin-bottom: 30px;
    object-fit: contain;
}
.gradient-overlay {
    position: absolute;
    top: 0; left: 0; width: 100%; height: 100%;
    background: linear-gradient(135deg, var(--theme-color) 0%, #000 100%);
    opacity: 0.8;
}
.modern-content {
    position: relative;
    z-index: 2;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 40px;
    color: white;
}
.m-btn {
    background: rgba(255,255,255,0.1);
    backdrop-filter: blur(10px);
    border-radius: 15px;
    padding: 30px;
    margin: 10px 0;
    text-align: center;
}

/* TEMPLATE 4: Elegant Classic */
.elegant-classic {
    padding: 0;
    background: #fffafa;
}
.classic-header {
    padding: 40px;
    text-align: center;
    border-bottom: 3px double #333;
}
.classic-logo { 
    max-width: 100%; 
    height: auto;
    width: 200px;
    object-fit: contain;
}
@media (max-width: 600px) {
    .classic-logo { width: 70%; }
}
.about-us-section {
    padding: 40px;
    text-align: center;
    line-height: 1.8;
}
.classic-btn {
    width: 80%;
    margin: 10px auto;
    display: block;
    padding: 12px;
    border: 1px solid #333;
    background: white;
}

/* TEMPLATE 5: Restaurant Modern */
.restaurant-hero {
    height: 40vh;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
}
.hero-content {
    background: rgba(0,0,0,0.5);
    padding: 20px;
    text-align: center;
    color: white;
    width: 80%;
}
.restaurant-info {
    padding: 30px;
}
.res-link-item {
    padding: 15px;
    border-left: 4px solid var(--theme-color);
    margin: 15px 0;
    background: #fdfdfd;
}

/* COMMON */
.waiter-icon { width: 40px; }
@media (max-width: 600px) {
    .actions-grid { grid-template-columns: 1fr; }
    .hero-section { flex: 2; }
}

/* TEMPLATE 6 REWRITE */
.template-6.fresh-modern {
  background-color: #fcfcfc;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Inter', sans-serif;
  color: #1a202c;
  padding: 80px 40px;
  gap: 80px;
  align-items: center;
}

.t6-hero, .t6-cta {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 800px;
  width: 100%;
}

.t6-title, .t6-cta-title {
  font-size: 46px;
  font-weight: 800;
  margin-bottom: 20px;
  color: #1a202c;
  letter-spacing: -0.5px;
}

.t6-subtitle, .t6-cta-subtitle {
  font-size: 18px;
  color: #4a5568;
  margin-bottom: 32px;
  line-height: 1.6;
}

.t6-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

.t6-btn {
  padding: 12px 28px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.2s ease;
}

.t6-btn-dark {
  background-color: #111827;
  color: #ffffff;
  border: 1px solid #111827;
}
.t6-btn-dark:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 15px rgba(0,0,0,0.1);
}

.t6-btn-outline {
  background-color: #ffffff;
  color: #111827;
  border: 1px solid #e2e8f0;
}
.t6-btn-outline:hover {
  border-color: #cbd5e1;
  background-color: #f8fafc;
}

.t6-features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 24px;
  width: 100%;
  max-width: 1000px;
}

.t6-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 30px 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 1px 3px rgba(0,0,0,0.02);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.t6-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.05);
}

.t6-icon {
  font-size: 26px;
  color: #1a202c;
  margin-bottom: 20px;
}

.t6-card h4 {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 12px;
  color: #1a202c;
}

.t6-card p {
  font-size: 14px;
  color: #718096;
  line-height: 1.5;
}

.t6-map-section {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
}

.t6-footer-strip {
  width: 100%;
  max-width: 1000px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 40px;
  border-top: 1px solid #e2e8f0;
  flex-wrap: wrap;
  gap: 20px;
}

.t6-contact-info {
  display: flex;
  align-items: center;
  gap: 24px;
}

.t6-contact-link {
  color: #4a5568;
  font-size: 26px;
  transition: color 0.2s;
  display: flex;
  align-items: center;
}
.t6-contact-link:hover {
  color: #1a202c;
}

.t6-piva {
  font-size: 14px;
  color: #718096;
  font-weight: 500;
}

.t6-waiter {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  font-weight: 600;
  color: #1a202c;
}
.t6-waiter img {
  width: 32px;
}

@media (max-width: 768px) {
  .t6-title, .t6-cta-title { font-size: 32px; }
  .t6-subtitle, .t6-cta-subtitle { font-size: 16px; margin-bottom: 24px; }
  .t6-actions { flex-direction: column; width: 100%; }
  .t6-btn { width: 100%; justify-content: center; }
  .template-6.fresh-modern { padding: 40px 20px; gap: 50px; }
  .t6-footer-strip { flex-direction: column; text-align: center; justify-content: center; gap: 30px; }
  .t6-contact-info { flex-direction: column; gap: 16px; }
}

.public-payment-overlay {
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  width: 90%;
  max-width: 420px;
}

.pay-btn-shared {
  width: 100%;
  padding: 18px 32px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  border-radius: 20px;
  font-weight: 800;
  font-size: 1.15rem;
  box-shadow: 0 15px 30px -5px rgba(16, 185, 129, 0.5);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  letter-spacing: -0.01em;
}

.pay-btn-shared:hover {
  transform: translateX(-50%) translateY(-5px);
  box-shadow: 0 20px 40px -8px rgba(16, 185, 129, 0.6);
}

.pay-btn-shared:active {
  transform: translateX(-50%) translateY(0);
}

.recap-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.8);
  backdrop-filter: blur(12px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  padding: 20px;
}

.recap-modal {
  background: white;
  width: 100%;
  max-width: 460px;
  border-radius: 32px;
  overflow: hidden;
  box-shadow: 0 30px 60px -12px rgba(0, 0, 0, 0.45);
  display: flex;
  flex-direction: column;
  animation: modal-slide-up 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes modal-slide-up {
  from { opacity: 0; transform: translateY(40px) scale(0.96); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.recap-header {
  padding: 32px 32px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.recap-header h2 {
  margin: 0;
  font-size: 1.6rem;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.03em;
}

.close-recap {
  background: #f1f5f9;
  border: none;
  font-size: 22px;
  width: 44px;
  height: 44px;
  border-radius: 14px;
  cursor: pointer;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.close-recap:hover {
  background: #fee2e2;
  color: #ef4444;
  transform: rotate(90deg);
}

.recap-body {
  padding: 0 32px 32px;
  max-height: 50vh;
  overflow-y: auto;
}

.recap-body::-webkit-scrollbar { width: 4px; }
.recap-body::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 10px; }

.recap-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #f1f5f9;
}

.item-main-info {
  display: flex;
  align-items: center;
  gap: 14px;
}

.item-qty-tag {
  background: #ecfdf5;
  color: #059669;
  font-weight: 800;
  font-size: 0.8rem;
  padding: 4px 10px;
  border-radius: 8px;
}

.item-name-text {
  font-weight: 600;
  color: #334155;
  font-size: 1.05rem;
}

.item-price-val {
  font-weight: 700;
  color: #0f172a;
  font-size: 1.05rem;
}

/* Payment Modes - High End Selection */
.payment-modes {
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-top: 10px;
}

.modes-intro {
  font-weight: 700;
  color: #64748b;
  font-size: 0.95rem;
  margin-bottom: 4px;
  text-align: center;
}

.btn-mode-premium {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px;
  border: 2px solid #f1f5f9;
  border-radius: 22px;
  background: white;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  width: 100%;
  position: relative;
}

.btn-mode-premium:hover {
  border-color: #10b981;
  background: #f8fafc;
  transform: translateY(-4px);
  box-shadow: 0 12px 24px -6px rgba(0, 0, 0, 0.08);
}

.mode-icon-box {
  width: 58px;
  height: 58px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  flex-shrink: 0;
  transition: all 0.3s;
}

.btn-mode-premium:hover .mode-icon-box {
  transform: scale(1.1);
}

.icon-full { background: #eff6ff; color: #3b82f6; }
.icon-split { background: #fff1f2; color: #f43f5e; }
.icon-items { background: #ecfdf5; color: #10b981; }

.mode-content {
  text-align: left;
}

.mode-content h4 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 800;
  color: #0f172a;
}

.mode-content p {
  margin: 4px 0 0;
  font-size: 0.9rem;
  color: #64748b;
  line-height: 1.4;
}

.chevron-arrow {
  margin-left: auto;
  color: #cbd5e1;
  font-size: 1rem;
  transition: transform 0.3s;
}

.btn-mode-premium:hover .chevron-arrow {
  color: #10b981;
  transform: translateX(6px);
}

/* Inputs & Forms */
.form-field {
  margin-top: 24px;
}

.form-label {
  display: block;
  font-size: 0.95rem;
  font-weight: 700;
  color: #475569;
  margin-bottom: 12px;
}

.premium-input {
  width: 100%;
  padding: 18px;
  background: #f8fafc;
  border: 2px solid #f1f5f9;
  border-radius: 18px;
  font-size: 1.1rem;
  font-weight: 600;
  color: #0f172a;
  transition: all 0.2s;
}

.premium-input:focus {
  outline: none;
  border-color: #10b981;
  background: white;
  box-shadow: 0 0 0 5px rgba(16, 185, 129, 0.1);
}

/* Items Selection */
.items-list-premium {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.selection-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  border-radius: 20px;
  border: 2px solid #f1f5f9;
  background: #f8fafc;
  cursor: pointer;
  transition: all 0.2s;
}

.selection-card.selected {
  border-color: #10b981;
  background: #ecfdf5;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.1);
}

.selection-card.paid {
  opacity: 0.4;
  cursor: not-allowed;
  background: #f1f5f9;
}

/* Footer & Actions */
.recap-footer-premium {
  padding: 32px;
  background: #f8fafc;
  border-top: 1px solid #f1f5f9;
}

.total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
}

.total-label {
  font-size: 1.1rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.total-amount {
  font-size: 2rem;
  font-weight: 900;
  color: #0f172a;
  letter-spacing: -0.04em;
}

.actions-container {
  display: flex;
  gap: 16px;
}

.btn-secondary-premium {
  flex: 1;
  padding: 18px;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 18px;
  color: #475569;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-secondary-premium:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
  color: #0f172a;
}

.btn-primary-premium {
  flex: 2;
  padding: 18px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border: none;
  border-radius: 18px;
  color: white;
  font-weight: 800;
  font-size: 1.1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  box-shadow: 0 10px 20px -5px rgba(16, 185, 129, 0.4);
  transition: all 0.3s;
}

.btn-primary-premium:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 15px 30px -5px rgba(16, 185, 129, 0.5);
}

.btn-primary-premium:disabled {
  background: #cbd5e1;
  box-shadow: none;
  cursor: not-allowed;
}

.btn-mode-toggle {
  flex: 2;
  padding: 18px;
  background: #f1f5f9;
  border-radius: 18px;
  border: none;
  font-weight: 700;
  color: #475569;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 1rem;
}

.btn-mode-toggle:hover {
  background: #e2e8f0;
  color: #0f172a;
}
</style>